import Vue from 'vue'
import AccountLayout from '@/components/layout/account-layout'
import IntroLayout from '@/components/layout/intro-layout'
Vue.component("AccountLayout", AccountLayout)
Vue.component("AccountIntroLayout", IntroLayout)